import useI18n from "@/hooks/useI18n";
import SheetBackdrop from "@/atomic/atoms/SheetBackdrop";
import { PARTNER_CONCESSIONAIRE_NAMES } from "@/domain/scrapers/concessionaires";

interface PartnersConcessionairesDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

function ConcessionaireListItem({ name }: { name: string }) {
  return (
    <li className="flex items-center gap-3 py-3.5 border-b border-border">
      <span
        data-testid="concessionaire-dot"
        className="w-2 h-2 rounded-full bg-success shrink-0"
      />
      <p className="text-base font-primary text-text">{name}</p>
    </li>
  );
}

export default function PartnersConcessionairesDrawer({
  isOpen,
  onClose,
}: PartnersConcessionairesDrawerProps) {
  const { t } = useI18n();

  if (!isOpen) return null;

  return (
    <SheetBackdrop
      onClose={onClose}
      labelledBy="partners-drawer-title"
      panelClassName="px-6 pb-3 pt-2"
    >
      <div className="flex flex-col items-center shrink-0">
        <div className="w-11 h-1 bg-border rounded-[10px] mb-2" />
        <button
          type="button"
          onClick={onClose}
          className="self-end"
          aria-label={t("common:close")}
        >
          <img src="/svg/icon-close.svg" alt="" width={24} height={24} />
        </button>
      </div>

      <div
        data-testid="partners-drawer-scroll"
        className="flex-1 min-h-0 overflow-y-auto overscroll-contain scrollbar-thin-internal"
      >
        <h2
          id="partners-drawer-title"
          className="text-lg font-bold font-primary text-text tracking-[-0.1px]"
        >
          {t("pages:home:partnersDrawerTitle")}
        </h2>
        <p className="mt-2 text-sm font-light font-primary text-text-secondary leading-[1.4]">
          {t("pages:home:partnersDrawerDescription")}
        </p>

        <ul className="mt-2">
          {PARTNER_CONCESSIONAIRE_NAMES.map((name) => (
            <ConcessionaireListItem key={name} name={name} />
          ))}
        </ul>

        <h3 className="mt-5 text-lg font-bold font-primary text-text tracking-[-0.1px]">
          {t("pages:home:otherConcessionairesTitle")}
        </h3>
        <p className="mt-2 text-sm font-light font-primary text-text-secondary leading-[1.4]">
          {t("pages:home:otherConcessionairesDescription")}
        </p>
      </div>
    </SheetBackdrop>
  );
}
